<section *ngIf="selectedTemplate" [ngSwitch]="selectedTemplate.template">
  <app-group-a-template *ngSwitchCase="'A'" [examen]="examData"></app-group-a-template>
  <app-group-b-template *ngSwitchCase="'B'" [examen]="examData"></app-group-b-template>
  <app-group-c-template *ngSwitchCase="'C'" [examen]="examData"></app-group-c-template>
  <app-group-d-template *ngSwitchCase="'D'" [examen]="examData"></app-group-d-template>
  <app-group-e-template *ngSwitchCase="'E'" [examen]="examData"></app-group-e-template>
  <app-group-f-template *ngSwitchCase="'F'" [examen]="examData"></app-group-f-template>
  <app-group-g-template *ngSwitchCase="'G'" [examen]="examData"></app-group-g-template>
  <app-group-h-template *ngSwitchCase="'H'" [examen]="examData"></app-group-h-template>
  <app-group-k-template *ngSwitchCase="'K'" [examen]="examData"></app-group-k-template>

  <section *ngSwitchDefault class="mensajeTmp">
    <span>
      No se encontro el template correspondiente al examen de
    </span>
    <p>{{examData.tipoExamen}}</p>
  </section>
</section>
